import * as Yup from 'yup'

export function getValidation(stepName) {
    // console.log("getValidation stepName:", stepName)
    const validationSchemas = {
        "Approve Documents": Yup.object({  // Changed from "documents"
            missingSectionsString: Yup.string()
                .max(0, "Please complete all required sections before continuing"),
            agreement: Yup.boolean()
                .oneOf([true], "You must acknowledge the documents to proceed"),
            eligibleIndustryCertification: Yup.boolean()
                .oneOf([true], "You must confirm your business is eligible to use Salusion"),
        }),
    }
    return {
        validationSchema: validationSchemas[stepName] || Yup.object({})
    }
}

export default getValidation